import * as React from "react";
import {Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem} from "reactstrap";
import {StickyHelpButtonPopup} from "@falcon/plugin-falcon-journey";
import {resourcesHelper} from "@falcon/services";

export const DashboardNavbar = (props: any) => {
    const [isOpen, setIsOpen] = React.useState(false);

    const toggle = () => setIsOpen(!isOpen);

    return (
        <Navbar className="d-flex journey-header" expand="md">
            <div className="journey-header-background">
            <NavbarBrand>
                <a className="header-logo-link" id="goToAllianzHomePage" href="https://www.allianz.co.uk" target="_blank">
                    <img className="flow-logo" src={`/${resourcesHelper.THEME}/img/brand-logo.png`} alt={`${resourcesHelper.THEME} logo icon`} tabIndex={0}/>
                </a>
            </NavbarBrand>
            <NavbarToggler onClick={toggle}/>
            <Collapse isOpen={isOpen} navbar>
                <Nav className="ml-auto flex-column-reverse flex-md-row pt-3 pt-md-0" navbar>
                    <StickyHelpButtonPopup>
                        <NavItem>
                            <span id="help">Help</span>
                        </NavItem>
                    </StickyHelpButtonPopup>
                    <NavItem>
                        <span id="logout" role="link" tabIndex={0} onClick={props.logout} onKeyPress={props.logout}
                              aria-label="Log out">Log out</span>
                    </NavItem>
                </Nav>
            </Collapse>
            </div>
        </Navbar>
    );
};



// WEBPACK FOOTER //
// ./src/components/navigation/DashboardNavbar.tsx